/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerJoinedAt} from '../api'

 export const useQueryGetCustomerJoinedAt = createReactQueryHook('getCustomerJoinedAt', getCustomerJoinedAt)
